import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Marked } from 'marked';

// Utils
import cn from '@/utils/cn';
import { getLocale, normalizeInternalLink } from '@/utils/localeSlug';

// Styles
import styles from './Markdown.module.css';

interface MarkdownProps {
  text: string;
  className?: string;
}

function Markdown({
  text,
  className = '',
}: MarkdownProps) {
  const { pathname } = useLocation();
  const locale = getLocale(pathname);
  const siteUrl = import.meta.env.VITE_DOMAIN;

  const html = useMemo(() => {
    const marked = new Marked();
    marked.use({
      walkTokens(token) {
        if (token.type === 'link') {
          // eslint-disable-next-line no-param-reassign -- marked link transformer API
          token.href = normalizeInternalLink(token.href, locale, siteUrl);
        }
      },
    });
    return marked.parse(text, { async: false });
  }, [text, locale, siteUrl]);

  return (
    <div
      className={cn([
        className,
        styles.markdown
      ])}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default Markdown;
